export default __webpack_public_path__ + "static/media/yearbook-icon.fa6f6702.png";